import {SdkClientClass} from "./sdk";

export declare var SdkClient:SdkClientClass;
SdkClient = SdkClientClass.getInstance();